<template>
	<div class="card">
		<div class="card-body vstack gap-3">
			<div class="vstack lh-sm">
				<div>Últimas ventas generadas</div>
				<div class="text-muted text-sm">En los últimos 5 días</div>
			</div>
			<table class="table table-compact">
				<tbody>
					<tr v-if="placeholder && (sales ?? []).length == 0">
						<td class="placeholder-glow">
							<span class="col-3 placeholder rounded-pill"></span>
						</td>
					</tr>
					<tr v-else-if="!placeholder && (sales ?? []).length == 0">
						<td>
							No se encontraron resultados.
						</td>
					</tr>
					<SaleTableRow v-for="data in sales" v-bind:key="data.id" :sale="data" :selectable="false" v-else />
				</tbody>
			</table>
		</div>
		<div class="card-footer">
			<router-link :to="{ name: 'sale.index' }" class="link-primary">Ver todas<i class="bi bi-chevron-right ps-1 text-xs"></i></router-link>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			sales: Array,
			placeholder: {
				type: Boolean,
				default: false
			}
		}
	}
</script>